/**
 * Calculate the percentage difference from the mean.
 * @param mean  The mean value.
 * @param value The value.
 * @returns The percentage difference from the mean or 0 if either value is 0;
 */
export const calculatePercentageFromMean = (mean: number, value: number) => {
    if (mean === 0 || value === 0) {
        return 0;
    }

    const differenceFromMean = (value / mean - 1) * 100;

    return mean < 0 ? differenceFromMean * -1 : differenceFromMean;
};
